import { render, staticRenderFns } from "./upchatContactDialog.vue?vue&type=template&id=1325c436&lang=pug"
import script from "./upchatContactDialog.vue?vue&type=script&lang=js"
export * from "./upchatContactDialog.vue?vue&type=script&lang=js"
import style0 from "./upchatContactDialog.vue?vue&type=style&index=0&id=1325c436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports